import { Consumer, Context, Provider, createContext, useContext } from 'react'

type GenericProvider<T> = Provider<T>

type Hook<T> = () => T

type GenerateContext = <T>(
  defaultValue: T,
) => [GenericProvider<T>, Hook<T>, Consumer<T>, Context<T>]

export const generateContext: GenerateContext = (defaultValue) => {
  const _Ctx = createContext(defaultValue)

  const useHook = () => {
    const hookCtx = useContext(_Ctx)

    if (typeof hookCtx === 'undefined') {
      throw new Error('Context hook must be used inside of the Provider.')
    }
    return hookCtx
  }

  return [_Ctx.Provider, useHook, _Ctx.Consumer, _Ctx]
}
